/**
 * file : Authentication/ApiCall.jsx
 * 설명 : API 호출 모음
 */
import axios from "axios";
import store from '../../store';
import { newToken } from "../../store/actions";
import { AxiosCall, Swal, Fnc, Url } from "common/globals";
import { EventSourcePolyfill } from 'event-source-polyfill';

/**
 * 조회
 * @param {String} apiUrl API URL
 * @param {Function} setDatas 데이터 
 * @param {Function} setLoading 로딩 (기본 값 null)
 * @param {Array} searchWhere 조회 조건 (기본 값 null)
 * @param {Function} callBack CallBack 함수
 */
const Search = ( apiUrl, setDatas, setLoading = null, searchWhere = null, callBack = null ) => {

  !Fnc.Empty(setLoading) && setLoading(true)

  // 조회 조건
  if (!Fnc.Empty(searchWhere)) {
    apiUrl += "?"

    for (const key in searchWhere) {
      apiUrl += `&${key}=${searchWhere[key]}`
    }
  }

  AxiosCall.get(apiUrl)
  .then((result) => {
    // 페이징 처리인 경우 번호값 계산
    !Fnc.Empty(result.data.result_data.data) && (result.data.result_data.currIndex = result.data.result_data.total - (result.data.result_data.current_page - 1) * result.data.result_data.per_page)
    setDatas(result.data.result_data)
    !Fnc.Empty(callBack) && callBack(result.data)
  }).catch(err => {
    const response = err.response;
    Swal.SwalAlert('error', '오류', `<p>조회 오류 발생</p><div>${response.data.message}</div>`);
  }).finally(() => {
    !Fnc.Empty(setLoading) && setLoading(false)
  })
}
/**
 * 추가
 * @param {String} apiUrl API URL
 * @param {Object} datas 업데이트 데이터 
 * @param {Function} setLoading 로딩
 * @param {Function} callBack CallBack 함수
 */
const Insert = ( apiUrl, datas, setLoading, callBack = null ) => {

  setLoading(true)
  
  AxiosCall.post(apiUrl, datas)
  .then((result) => {
    !Fnc.Empty(callBack) && callBack()
    Swal.SwalAlert('success', '성공', `<div>${result.data.message}</div>`);
  }).catch(err => {
    const response = err.response;
    Swal.SwalAlert('error', '오류', `${response.data.message}</div>`);
  }).finally(() => {
    setLoading(false)
  })
}
/**
 * 업데이트
 * @param {String} apiUrl API URL
 * @param {String} type 호출 타입 (put, patch: 기본 값) 
 * @param {Object} datas 업데이트 데이터 
 * @param {Function} setLoading 로딩
 * @param {Boolean} alertYN 문구 발생 (true: 기본 값, false)
 * @param {Function} callBack CallBack 함수
 */
const Update = ( apiUrl, type = 'patch', datas, setLoading, alertYN = true, callBack = null ) => {

  setLoading(true)

  const api = type === 'put' ? AxiosCall.put : AxiosCall.patch
  
  api(apiUrl, datas)
  .then((result) => {
    !Fnc.Empty(callBack) && callBack()
    alertYN && Swal.SwalAlert('success', '성공', `<div>${result.data.message}</div>`);
  }).catch(err => {
    const response = err.response;
    alertYN && Swal.SwalAlert('error', '오류', `${response.data.message}</div>`);
  }).finally(() => {
    setLoading(false)
  })
}
/**
 * SEE
 */
const SSE = () => {
  let eventSource

  /**
   * SSE start
   * @param {Function} url API URL
   * @param {Function} success 정상 CallBack
   * @param {Function} error 에러 CallBack
   */
  const start = async (url, success, error) => {
    
    const { Client } = store.getState();

    try {
      const response = await axios.get(`${Url.ApiUrl}/api/token-check`, {
        headers: {
          'Authorization': `Bearer ${Client.token.access_token}`
        }
      });

      if (response.status === 200) {
        eventSource = new EventSourcePolyfill(Url.RealTimeUrl + url, {
          headers: {
            'Authorization': `Bearer ${Client.token.access_token}`
          }
        });
        // 서버로 부터 전달 받은 메세지
        eventSource.onmessage = (result) => {
          const data = JSON.parse(result.data);
          success(data);
        };
        // 통신중 오류
        eventSource.onerror = (err) => {
          error(err);
          eventSource.close();
        };
      }
    } catch (err) {
      const { response } = err;
      // 토큰 만료
      if (response && response.status === 401) {
        try {
          const response = await axios.get(`${Url.ApiUrl}/api/refresh-token`, {
            headers: {
              'Authorization': `Bearer ${Client.token.refresh_token}`
            }
          })
          // 토큰 갱신
          store.dispatch(newToken(response.data.token));
          // 함수 재호출
          start(url, success, error);
        } catch (err) {
          localStorage.clear();
          window.location.href = `${window.location.origin}/`
        }
      }
      console.error(err);
    }
  }
  /**
   * SSE stop
   */
  const stop = () => {
    !Fnc.Empty(eventSource) && eventSource.close();
  }

  return { start, stop }
}

export { Search, Insert, Update, SSE }